import { t } from 'i18next';
import { OnboardingFormFields } from '@Types/index.ts';
import { ControlledTextInput } from '../ControlledInputs';

interface IinputProps {
  disabled: boolean;
  tabIndex: number;
  isUS: boolean | undefined;
}
export const ZipInput = ({ tabIndex, disabled, isUS }: IinputProps) => {
  return (
    <ControlledTextInput
      name={OnboardingFormFields.ZIP}
      title={t('pages.businessAddress.fields.zip')}
      id={OnboardingFormFields.ZIP}
      disabled={disabled}
      tabindex={tabIndex}
      max={isUS ? 5 : 20}
      props={{ onChange: () => {}, id: '', title: '' }}
      filterType={isUS ? 'num' : undefined}
      shouldUpperCase={true}
      isPublic
    />
  );
};
